﻿import { IApprover } from "@/interfaces/IApprover";

export const flattenApprovers = (approvers: IApprover[]): IApprover[] => {
  if (!approvers?.length) return [];

  let tempList: IApprover[] = [];
  approvers?.forEach((approver) => {
    const dependantApprovers = approver.dependantApprovers
      ? flattenApprovers(approver.dependantApprovers)
      : [];
    tempList = [...tempList, approver, ...dependantApprovers];
  });

  return tempList;
};
